export function validateEcuadorianCI(cedula: string): boolean {
  let total = 0;
  const length = cedula.length;
  const lastDigit = parseInt(cedula[length - 1]);

  if (length !== 10) {
    return false;
  }

  for (let i = 0; i < length - 1; i++) {
    let digit = parseInt(cedula[i]);
    if (i % 2 === 0) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }
    total += digit;
  }

  const upperRound = Math.ceil(total / 10) * 10;
  return (upperRound - total === lastDigit) || (total % 10 === 0 && lastDigit === 0);
}